import React from 'react';
import s from './preventOrphanText.scss';

export interface PreventOrphanTextProps {
  children: typeof preventOrphanTextFn | string;
  n: number;
}

export const preventOrphanTextFn = (
  props: string | number | symbol | object,
  propName: string | number | symbol | undefined | null,
  componentName: string
): Error | string | null => {
  const p = propName as keyof typeof props;
  if (typeof props[p] !== 'string') {
    return new Error(
      `${componentName} only allows a string as a child, you supplied a ${typeof props[
        p
      ]}`
    );
  }
  return null;
};

const PreventOrphanText = ({
  children,
  n,
}: PreventOrphanTextProps): JSX.Element => {
  const bits = children.toString().split(/\s/);
  if (bits.length > n + 1) {
    return (
      <>
        {bits.slice(0, -n).join(' ')}{' '}
        <span className={s.preventOrphanText}>{bits.slice(-n).join(' ')}</span>
      </>
    );
  }
  return <>{children}</>;
};

PreventOrphanText.displayName = 'PreventOrphanText';

export default PreventOrphanText;
